import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_PETITIONS_USE_UNFILTERED_LIST = defineFcm('promoted_petitions_use_unfiltered_list')
	.asBoolean()
	.withDefault(false)
	.toConfig();
